export enum RunStatus {
    Empty = "empty",
    Pending = "pending",
    Ready = "ready",
    Running = "running",
}
